import SWRDiagram from "../../../../content/blog/14-02-2021-modern-data-fetching/swr.inline.svg";
import * as React from 'react';
export default {
  SWRDiagram,
  React
};